import React from 'react';
import { Badge } from 'react-bootstrap';

// Exhaustive Field Extractor Utilities (Resolves data across surveyData, fieldViewData, userInfo & top-level)
export const getLeadVillage = (row) => {
    const v = row.surveyData?.stages?.[0]?.form_data?.village ||
        row.surveyData?.stages?.[0]?.form_data?.village_name ||
        row.fieldViewData?.[0]?.village ||
        row.fieldViewData?.[0]?.village_name ||
        row.userInfo?.address?.village ||
        row.userInfo?.address?.village_name ||
        row.village_name ||
        row.village;
    return v && v !== 'null' && v !== 'undefined' ? v : '-';
};

export const getLeadBlock = (row) => {
    const b = row.surveyData?.stages?.[0]?.form_data?.block ||
        row.fieldViewData?.[0]?.block ||
        row.userInfo?.address?.block ||
        row.block;
    return b && b !== 'null' && b !== 'undefined' ? b : '-';
};

export const getLeadDistrict = (row) => {
    const d = row.surveyData?.stages?.[0]?.form_data?.district ||
        row.fieldViewData?.[0]?.district ||
        row.userInfo?.address?.district ||
        row.district;
    return d && d !== 'null' && d !== 'undefined' ? d : '-';
};

export const getLeadState = (row) => {
    const s = row.surveyData?.stages?.[0]?.form_data?.state ||
        row.fieldViewData?.[0]?.state ||
        row.userInfo?.address?.state ||
        row.state;
    return s && s !== 'null' && s !== 'undefined' ? s : '-';
};

export const getLeadAadhaar = (row) => {
    const a = row.surveyData?.stages?.[0]?.form_data?.aadhar_number ||
        row.surveyData?.stages?.[0]?.form_data?.aadharNumber ||
        row.fieldViewData?.[0]?.aadhar_number ||
        row.userInfo?.aadharNumber ||
        row.userInfo?.aadhar_number ||
        row.aadhar_number ||
        row.aadharNumber;
    return a && a !== 'null' && a !== 'undefined' ? a : '-';
};

export const getLeadSrlm = (row) => {
    if (row.surveyData?.stages?.[0]?.form_data?.srlm_associated !== undefined) {
        return row.surveyData.stages[0].form_data.srlm_associated;
    }
    if (row.srlm_associated !== undefined) return row.srlm_associated;
    return false;
};

const calculateAge = (row) => {
    const dobStr = row.surveyData?.stages?.[0]?.form_data?.dob || row.dob;
    if (dobStr) {
        const dob = new Date(dobStr);
        if (!isNaN(dob.getTime())) {
            const diff = Date.now() - dob.getTime();
            const ageDate = new Date(diff);
            return Math.abs(ageDate.getUTCFullYear() - 1970);
        }
    }
    return row.age || '-';
};

export const getHouseholdColumns = (openQuickView) => [
    {
        dataField: 'sno',
        text: 'S.No.',
        headerStyle: { width: '55px', minWidth: '55px', textAlign: 'center' },
        style: { width: '55px', minWidth: '55px', textAlign: 'center', fontWeight: 600 },
        formatter: (_, __, index) => index + 1
    },
    {
        dataField: 'name',
        text: 'Name',
        headerStyle: { width: '160px', minWidth: '160px' },
        style: { width: '160px', minWidth: '160px', wordBreak: 'break-word', whiteSpace: 'normal' },
        formatter: (_, row) => {
            const userId = row.userInfo?._id || row._id;
            const name = row.userInfo?.name || row.name || 'N/A';
            return (
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                    <a
                        href={`/user-profile/${userId}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontWeight: 700, color: '#2563eb', textDecoration: 'none' }}
                    >
                        {name}
                    </a>
                    <span
                        onClick={() => openQuickView(userId)}
                        title="Quick View Details"
                        style={{
                            cursor: 'pointer',
                            fontSize: '14px',
                            color: '#ff8701',
                            transition: 'transform 0.15s ease',
                            display: 'inline-block'
                        }}
                        onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.25)'}
                        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                    >
                        👁️
                    </span>
                </div>
            );
        }
    },
    {
        dataField: 'surveyorName',
        text: 'Surveyed By',
        headerStyle: { width: '130px', minWidth: '130px' },
        style: { width: '130px', minWidth: '130px', wordBreak: 'break-word', whiteSpace: 'normal' },
        sort: true,
        formatter: (cell, row) => {
            const surveyor = cell || row.surveyorName || row.surveyData?.created_by?.name || row.created_by_user?.name || row.surveyedBy || row.fieldViewData?.[0]?.surveyor_name || '-';
            return <span style={{ fontWeight: 600, color: '#475569' }}>{surveyor}</span>;
        }
    },
    {
        dataField: 'stage',
        text: 'Stage',
        headerStyle: { width: '90px', minWidth: '90px' },
        style: { width: '90px', minWidth: '90px' },
        formatter: (cell) => (
            <Badge variant={cell === 'advance' ? 'primary' : 'secondary'} style={{ padding: '4px 8px', fontSize: '11px', fontWeight: 700 }}>
                {cell === 'advance' ? 'Advanced' : 'Basic'}
            </Badge>
        )
    },
    {
        dataField: 'gender',
        text: 'Gender',
        headerStyle: { width: '70px', minWidth: '70px' },
        style: { width: '70px', minWidth: '70px' },
        formatter: (_, row) => {
            const g = row.userInfo?.gender || row.gender;
            if (!g) return '-';
            return g.charAt(0).toUpperCase() + g.slice(1).toLowerCase();
        }
    },
    {
        dataField: 'age',
        text: 'Age',
        headerStyle: { width: '50px', minWidth: '50px', textAlign: 'center' },
        style: { width: '50px', minWidth: '50px', textAlign: 'center' },
        formatter: (_, row) => calculateAge(row)
    },
    {
        dataField: 'mobileNumber',
        text: 'Mobile No.',
        headerStyle: { width: '120px', minWidth: '120px' },
        style: { width: '120px', minWidth: '120px' },
        formatter: (_, row) => {
            const mobile = row.userInfo?.mobileNumber || row.mobile_number || '-';
            return <span style={{ fontFamily: 'monospace', fontWeight: 700, color: '#1e293b' }}>{mobile}</span>;
        }
    },
    {
        dataField: 'state',
        text: 'State',
        headerStyle: { width: '120px', minWidth: '120px' },
        style: { width: '120px', minWidth: '120px', wordBreak: 'break-word', whiteSpace: 'normal' },
        formatter: (_, row) => getLeadState(row)
    },
    {
        dataField: 'district',
        text: 'District',
        headerStyle: { width: '130px', minWidth: '130px' },
        style: { width: '130px', minWidth: '130px', wordBreak: 'break-word', whiteSpace: 'normal' },
        formatter: (_, row) => getLeadDistrict(row)
    },
    {
        dataField: 'village',
        text: 'Village',
        headerStyle: { width: '120px', minWidth: '120px' },
        style: { width: '120px', minWidth: '120px', wordBreak: 'break-word', whiteSpace: 'normal' },
        formatter: (_, row) => getLeadVillage(row)
    },
    {
        dataField: 'block',
        text: 'Block',
        headerStyle: { width: '130px', minWidth: '130px' },
        style: { width: '130px', minWidth: '130px', wordBreak: 'break-word', whiteSpace: 'normal' },
        formatter: (_, row) => getLeadBlock(row)
    },
    {
        dataField: 'aadharNumber',
        text: 'Aadhaar Number',
        headerStyle: { width: '130px', minWidth: '130px' },
        style: { width: '130px', minWidth: '130px' },
        formatter: (_, row) => getLeadAadhaar(row)
    },
    {
        dataField: 'srlm_associated',
        text: 'SRLM Associated',
        headerStyle: { width: '130px', minWidth: '130px', paddingRight: '12px' },
        style: { width: '130px', minWidth: '130px', textAlign: 'center' },
        formatter: (_, row) => (getLeadSrlm(row) ? 'Yes' : 'No')
    },
    {
        dataField: 'clusterName',
        text: 'Cluster Name',
        headerStyle: { width: '160px', minWidth: '160px', paddingLeft: '12px' },
        style: { width: '160px', minWidth: '160px', wordBreak: 'break-word', whiteSpace: 'normal', fontWeight: 600, color: '#6b21a8' },
        formatter: (cell) => (
            <span style={{ fontWeight: 600, color: '#6b21a8', display: 'inline-block' }}>
                {cell || 'N/A'}
            </span>
        )
    },
    {
        dataField: 'hivesCount',
        text: 'Hives Count',
        headerStyle: { width: '100px', minWidth: '100px', textAlign: 'center' },
        style: { width: '100px', minWidth: '100px', textAlign: 'center' },
        sort: true,
        formatter: (cell) => (
            <span style={{ fontWeight: 800, color: '#16a34a', fontSize: '13px' }}>
                {cell || 10} Hives
            </span>
        )
    },
    {
        dataField: 'visitCount',
        text: 'Total Visits',
        headerStyle: { width: '110px', minWidth: '110px', textAlign: 'center' },
        style: { width: '110px', minWidth: '110px', textAlign: 'center' },
        sort: true,
        formatter: (cell) => (
            <Badge pill style={{ backgroundColor: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe', padding: '5px 10px', fontSize: '11px', fontWeight: 700 }}>
                {cell || 0} Visits
            </Badge>
        )
    },
    {
        dataField: 'lastVisitedOn',
        text: 'Last Visited On',
        headerStyle: { width: '150px', minWidth: '150px' },
        style: { width: '150px', minWidth: '150px', wordBreak: 'break-word', whiteSpace: 'normal' },
        formatter: (cell) => (
            <span style={{ fontWeight: 600, color: '#475569', fontSize: '12px' }}>
                {cell || '-'}
            </span>
        )
    },
    {
        dataField: 'lastVisitedBy',
        text: 'Last Visited By',
        headerStyle: { width: '160px', minWidth: '160px' },
        style: { width: '160px', minWidth: '160px', wordBreak: 'break-word', whiteSpace: 'normal' },
        formatter: (cell, row) => {
            if (!cell || cell === '-') return '-';
            const targetId = row.lastVisitedById;
            return targetId ? (
                <a
                    href={`/user-profile/${targetId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ fontWeight: 700, color: '#2563eb', textDecoration: 'none' }}
                >
                    {cell} 🔗
                </a>
            ) : (
                <span style={{ fontWeight: 700, color: '#334155' }}>
                    {cell}
                </span>
            );
        }
    },
    {
        dataField: 'apiaryStatus',
        text: 'Apiary',
        headerStyle: { width: '80px', minWidth: '80px' },
        style: { width: '80px', minWidth: '80px' },
        formatter: () => (
            <Badge variant="success" style={{ padding: '5px 10px', fontSize: '11px', fontWeight: 700, backgroundColor: '#16a34a' }}>
                🟢 Active
            </Badge>
        )
    },
    {
        dataField: 'projectName',
        text: 'Project Name',
        headerStyle: { width: '160px', minWidth: '160px' },
        style: { width: '160px', minWidth: '160px', wordBreak: 'break-word', whiteSpace: 'normal' },
        formatter: (cell, row) => (
            <span style={{ fontWeight: 700, color: '#16a34a' }}>
                {cell || row.clusterName || 'Dantewada PMDDKY - Had X NSC'}
            </span>
        )
    }
];
